import styled from 'styled-components/macro'
import { getGelTokens } from '@tal-gel/theming'

import margin from '../../styles/margin'

const Title = styled.h3`
  font-family: 'Pluto Sans', sans-serif;
  font-weight: bold;
  font-size: 24px;
  line-height: 28px;
  color: ${() => getGelTokens().brand.brandColorGrayT90};
  margin-bottom: 8px;
`

const HugeTitle = styled(Title)`
  @media only screen and (min-width: 768px) {
    font-size: 40px;
    line-height: 48px;
  }
`

const MediumTitle = styled(Title)`
  @media only screen and (min-width: 768px) {
    font-size: 32px;
    line-height: 40px;
  }
`

const Text = styled.p`
  ${margin};

  font-family: 'Pluto Sans', sans-serif;
  font-weight: ${(props) => (props.bold ? 'bold' : 'normal')};
  font-size: 16px;
  line-height: 24px;
  color: ${(props) => props.theme.colors.grey.grey7};
  color: ${() => getGelTokens().brand.brandColorGrayT50};

  @media only screen and (min-width: 768px) {
    font-size: 20px;
    line-height: 32px;
  }
`

export { Title, HugeTitle, MediumTitle, Text }
